// Status und Filter der Mieterselbstauskunft — die Regeln getrennt von der Maske, damit sie
// prüfbar sind. Farbwahl vom User vorgegeben (2026-08-09): Neu blau, Geprüft gelb,
// Angenommen grün, Abgelehnt rot — auf einen Blick erkennbar, wo eine Neuvermietung steht.
// „Eingeladen“ (violett) kam mit Ticket #375 dazu: wer zur Besichtigung eingeladen ist.

export type SelbstauskunftStatus = 'neu' | 'geprueft' | 'eingeladen' | 'angenommen' | 'abgelehnt';

export const STATUS_REIHENFOLGE: SelbstauskunftStatus[] = ['neu', 'geprueft', 'eingeladen', 'angenommen', 'abgelehnt'];

export const STATUS_LABEL: Record<SelbstauskunftStatus, string> = {
  neu: 'Neu',
  geprueft: 'Geprüft',
  eingeladen: 'Eingeladen',
  angenommen: 'Angenommen',
  abgelehnt: 'Abgelehnt',
};

/** Ruhige Variante (Badge in der Liste). */
export const STATUS_BADGE: Record<SelbstauskunftStatus, string> = {
  neu: 'bg-blue-50 text-blue-600 border-blue-200',
  geprueft: 'bg-amber-50 text-amber-700 border-amber-200',
  eingeladen: 'bg-violet-50 text-violet-700 border-violet-200',
  angenommen: 'bg-green-50 text-green-700 border-green-200',
  abgelehnt: 'bg-red-50 text-red-600 border-red-200',
};

/** Kräftige Variante (aktiver Knopf im Detail / aktiver Filter). */
export const STATUS_AKTIV: Record<SelbstauskunftStatus, string> = {
  neu: 'bg-blue-600 border-blue-600 text-white',
  geprueft: 'bg-amber-500 border-amber-500 text-white',
  eingeladen: 'bg-violet-600 border-violet-600 text-white',
  angenommen: 'bg-green-600 border-green-600 text-white',
  abgelehnt: 'bg-red-600 border-red-600 text-white',
};

export interface FilterbarerEingang {
  status: SelbstauskunftStatus;
  objekt_id: string | null;
  created_at: string;
}

export interface SelbstauskunftFilter {
  status?: SelbstauskunftStatus | 'alle';
  objektId?: string | 'alle';
  /** Tagesgenau, Format YYYY-MM-DD; leer = keine Grenze. */
  von?: string;
  bis?: string;
}

/** Eingangsdatum als YYYY-MM-DD (lokale Zeit) — Grundlage des Datumsfilters. */
export function tagVon(zeitpunkt: string): string {
  const d = new Date(zeitpunkt);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** Status, Objekt und Zeitraum kombiniert — jeder Teil wirkt nur, wenn er gesetzt ist. */
export function filtereEingaenge<T extends FilterbarerEingang>(liste: T[], filter: SelbstauskunftFilter): T[] {
  const { status = 'alle', objektId = 'alle', von = '', bis = '' } = filter;
  return liste.filter((e) => {
    if (status !== 'alle' && e.status !== status) return false;
    if (objektId !== 'alle') {
      const eigen = e.objekt_id ?? 'ohne';
      if (eigen !== objektId) return false;
    }
    if (von || bis) {
      const tag = tagVon(e.created_at);
      if (!tag) return false;
      if (von && tag < von) return false;
      if (bis && tag > bis) return false;
    }
    return true;
  });
}
